export function getImageSrc(src: string): string {
	if (process.env.CONTEXT_PATH)
		src = `${process.env.CONTEXT_PATH}/${src.substring(process.env.CONTEXT_PATH.length)}`
	return src
}